import { CheckCircleIcon } from '@systemeio/ui/icons'
import { PrimaryButton } from '@systemeio/ui'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { twMerge } from 'tailwind-merge'
import { CourseThemeColorSetInterface } from '../types/course-theme-color-set-interface'
import CourseThemePreview from './course-theme-preview'

interface CourseThemeSelectItemProps {
  theme: CourseThemeColorSetInterface
  selected: boolean
  id: number
  onChange: (id: number) => void
}

const CourseThemeSelectItem = ({ theme, selected, onChange, id }: CourseThemeSelectItemProps) => {
  const { t } = useLocoTranslation()

  return (
    <div
      role="radio"
      aria-checked={selected}
      onClick={selected ? undefined : () => onChange(id)}
      className={twMerge(
        'group relative min-h-[190px] overflow-hidden rounded-xl',
        selected ? 'border-green border-2' : 'cursor-pointer',
      )}
    >
      <CourseThemePreview theme={theme} themeId={id} />
      <div
        className={twMerge(
          'bg-background-secondary/50 absolute top-0 h-full w-full items-center justify-center',
          selected ? 'flex' : 'hidden group-hover:flex',
        )}
      >
        {selected ? (
          <span className="text-green flex gap-2 font-bold">
            <CheckCircleIcon className="fill-green" />
            {t('dashboard.course.theme_selected')}
          </span>
        ) : (
          <PrimaryButton className="bg-green hover:bg-green">
            {t('dashboard.course.select_theme')}
          </PrimaryButton>
        )}
      </div>
    </div>
  )
}

export default CourseThemeSelectItem
